import { BonusItem } from "types/Bonus";
import useTranslate from "hooks/useTranslate";

// eslint-disable-line import/no-extraneous-dependencies
import { WELCOME_ITEM } from "../../../constants/bonus";
import useFormatNumber from "../../../hooks/useFormatNumber";

import "./styles.sass";

type WelcomeBonusCardItemProps = {
  bonus: BonusItem;
  min?: number;
  max?: number;
  freeSpins?: number;
};

const WelcomeBonusCardItem = (props: WelcomeBonusCardItemProps) => {
  const { min, max, freeSpins, bonus } = props;
  const t = useTranslate();
  const formatNumber = useFormatNumber();

  const getValue = () => {
    if (bonus.name === "bonus.back.category.spins") {
      return t("casino.sidebar.slots");
    }
    if (bonus.name === "bonus.back.amount.slots") {
      return t(bonus.value);
    }
    if (bonus.name === "bonus.title.necessary.conditions") {
      return t(bonus.value);
    }
    if (bonus.name === "bonus.back.spins") {
      return t(bonus.value);
    }
    if (bonus.name === "bonus.back.game") {
      return t(bonus.value);
    }
    if (bonus.name === "bonus.back.amount") {
      return t(bonus.value);
    }
    if (bonus.id === WELCOME_ITEM.MIN) {
      return min && formatNumber(min, 0, true);
    }
    if (bonus.id === WELCOME_ITEM.MAX) {
      return max && formatNumber(max, 0, true);
    }
    if (bonus.id === WELCOME_ITEM.FREE_SPINS) {
      return freeSpins && formatNumber(freeSpins, 0, true);
    }
    if (bonus.value.includes("x")) {
      return t(bonus.value);
    }
    if (bonus.name.includes(".progress")) {
      return bonus.value;
    }

    return t(bonus.value);
  };

  return (
    <div className="WelcomeBonusCardItem">
      <span className="WelcomeBonusCardItem__name">{t(bonus.name)}</span>
      <span className="WelcomeBonusCardItem__value">{getValue()}</span>
    </div>
  );
};

export default WelcomeBonusCardItem;
